export interface IFilterDisplayOptions {
    shadow: DisplayRule;
    glow: DisplayRule;
    softEdge: DisplayRule;
    reflection: DisplayRule;
    image: DisplayRule;
}

export enum DisplayRule {
    /** 不显示效果 */
    None,
    /** 文本显示效果 */
    Text,
    /** 形状显示效果 */
    Shape,
    /** 两者都显示效果 */
    Both,
}

export enum DisplayScene {
    Text = 'Text',
    Shape = 'Shape',
}

export const DefaultDisplayOptions = {
    shadow: DisplayRule.Both,
    glow: DisplayRule.Both,
    softEdge: DisplayRule.Both,
    reflection: DisplayRule.Both,
    image: DisplayRule.Both,
};

export function isShowFilter(rule: DisplayRule, scene: DisplayScene): boolean {
    let isShow = false;
    if (rule === DisplayRule.Both) {
        isShow = true;
    } else if (rule === DisplayRule.Text && scene === DisplayScene.Text) {
        isShow = true;
    } else if (rule === DisplayRule.Shape && scene === DisplayScene.Shape) {
        isShow = true;
    }

    return isShow;
}
